/**
 * Ritual circuit switcher — same behaviour as media-switch (tiles + autoplay).
 * Video: no native controls, muted, play/pause on active tile (incl. YouTube/Vimeo).
 */
(function () {
  var DEFAULT_AUTOPLAY_MS = 6000;
  var MIN_AUTOPLAY_MS = 1000;
  var MAX_AUTOPLAY_MS = 120000;
  var TILE = '[data-ritual-circuit-tile]';

  function getAutoplayMs(root) {
    var raw = root.getAttribute('data-autoplay-ms');
    var n = parseInt(String(raw), 10);
    if (isNaN(n) || n < 1) return 0;
    if (n < MIN_AUTOPLAY_MS) return MIN_AUTOPLAY_MS;
    if (n > MAX_AUTOPLAY_MS) return MAX_AUTOPLAY_MS;
    return n;
  }

  function postYouTubeCommand(iframe, command) {
    if (!iframe || !iframe.contentWindow) return;
    try {
      iframe.contentWindow.postMessage(
        JSON.stringify({ event: 'command', func: command, args: [] }),
        'https://www.youtube.com'
      );
    } catch (e) {}
  }

  function postVimeoMethod(iframe, method) {
    if (!iframe || !iframe.contentWindow) return;
    try {
      iframe.contentWindow.postMessage(JSON.stringify({ method: method }), '*');
    } catch (e) {}
  }

  function syncTileMedia(root) {
    var allTiles = root.querySelectorAll(TILE);
    for (var i = 0; i < allTiles.length; i++) {
      var tile = allTiles[i];
      var isActive = tile.classList.contains('is-active');
      var v = tile.querySelector('video');
      if (v) {
        if (isActive) {
          try {
            v.muted = true;
            v.currentTime = 0;
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } catch (e) {}
        } else {
          try {
            v.pause();
          } catch (e) {}
        }
        continue;
      }
      var yt = tile.querySelector('iframe.js-youtube');
      if (yt) {
        postYouTubeCommand(yt, isActive ? 'playVideo' : 'pauseVideo');
        continue;
      }
      var vi = tile.querySelector('iframe.js-vimeo');
      if (vi) {
        postVimeoMethod(vi, isActive ? 'play' : 'pause');
      }
    }
  }

  function pauseAllVideoLike(root) {
    var allTiles = root.querySelectorAll(TILE);
    for (var i = 0; i < allTiles.length; i++) {
      var tile = allTiles[i];
      var v = tile.querySelector('video');
      if (v) {
        try {
          v.pause();
        } catch (e) {}
        continue;
      }
      var yt = tile.querySelector('iframe.js-youtube');
      if (yt) {
        postYouTubeCommand(yt, 'pauseVideo');
        continue;
      }
      var vi = tile.querySelector('iframe.js-vimeo');
      if (vi) postVimeoMethod(vi, 'pause');
    }
  }

  function scheduleSyncActiveMedia(root) {
    function doSync() {
      syncTileMedia(root);
    }
    var hasIframe = root.querySelector('iframe.js-youtube, iframe.js-vimeo');
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () {
        window.setTimeout(doSync, hasIframe ? 150 : 0);
      });
    } else {
      window.setTimeout(doSync, hasIframe ? 150 : 0);
    }
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function init(root) {
    if (!root || root.dataset.ritualCircuitReady) return;
    root.dataset.ritualCircuitReady = 'true';

    var tiles = root.querySelectorAll('[data-ritual-circuit-tile]');
    var intervalId = null;

    function stopAutoplay() {
      if (intervalId !== null) {
        clearInterval(intervalId);
        intervalId = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      var ms = getAutoplayMs(root);
      if (tiles.length <= 1 || prefersReducedMotion() || ms < 1) return;
      intervalId = setInterval(function () {
        if (document.hidden) return;
        var activeIndex = 0;
        for (var i = 0; i < tiles.length; i++) {
          if (tiles[i].classList.contains('is-active')) {
            activeIndex = i;
            break;
          }
        }
        setActive((activeIndex + 1) % tiles.length);
      }, ms);
    }

    function setActive(index) {
      var idx = parseInt(String(index), 10);
      if (isNaN(idx) || idx < 0 || idx >= tiles.length) return;

      tiles.forEach(function (tile, i) {
        var on = i === idx;
        tile.classList.toggle('is-active', on);
        tile.setAttribute('aria-pressed', on ? 'true' : 'false');
        tile.setAttribute('tabindex', on ? '0' : '-1');
      });

      scheduleSyncActiveMedia(root);
    }

    function onVisibilityChange() {
      if (document.hidden) {
        stopAutoplay();
        pauseAllVideoLike(root);
        return;
      }
      startAutoplay();
      scheduleSyncActiveMedia(root);
    }

    function cleanup() {
      stopAutoplay();
      pauseAllVideoLike(root);
      document.removeEventListener('visibilitychange', onVisibilityChange);
      if (root._ritualCircuitMotionQuery && root._ritualCircuitMotionHandler) {
        var mq = root._ritualCircuitMotionQuery;
        var mh = root._ritualCircuitMotionHandler;
        mq.removeEventListener('change', mh);
        root._ritualCircuitMotionQuery = null;
        root._ritualCircuitMotionHandler = null;
      }
      if (root._ritualRcsDetailsSamePath) {
        root.removeEventListener('click', root._ritualRcsDetailsSamePath, true);
        root._ritualRcsDetailsSamePath = null;
      }
      delete root.dataset.ritualCircuitReady;
    }

    root._ritualCircuitCleanup = cleanup;

    function stopRcsActionBubbleToTile(e) {
      e.stopPropagation();
    }
    root.querySelectorAll('.r3nu-rcs__actions').forEach(function (actions) {
      actions.addEventListener('click', stopRcsActionBubbleToTile);
    });

    function normalizePathname(p) {
      if (!p || p === '') return '/';
      var s = p.replace(/\/$/, '') || '/';
      return s;
    }

    function onRcsDetailsSamePathScrollTop(e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var a = t.closest('a.r3nu-rcs__link[data-r3nu-rcs-secondary]');
      if (!a || !root.contains(a)) return;
      var href = a.getAttribute('href');
      if (!href || href === '#' || href === '') return;
      try {
        var link = new URL(a.getAttribute('href'), window.location.origin);
        if (link.origin !== window.location.origin) return;
        if (normalizePathname(link.pathname) !== normalizePathname(window.location.pathname)) return;
        e.preventDefault();
        e.stopPropagation();
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          window.scrollTo(0, 0);
        } else {
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }
      } catch (err) {}
    }
    root.addEventListener('click', onRcsDetailsSamePathScrollTop, true);
    root._ritualRcsDetailsSamePath = onRcsDetailsSamePathScrollTop;

    function makeTileKeyHandler(t) {
      return function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        if (e.target && e.target.closest && e.target.closest('.r3nu-rcs__actions')) return;
        e.preventDefault();
        setActive(t.getAttribute('data-ritual-circuit-tile'));
        startAutoplay();
      };
    }

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        setActive(tile.getAttribute('data-ritual-circuit-tile'));
        startAutoplay();
      });
      tile.addEventListener('keydown', makeTileKeyHandler(tile));
    });

    document.addEventListener('visibilitychange', onVisibilityChange);

    if (window.matchMedia) {
      var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      root._ritualCircuitMotionQuery = motionQuery;
      root._ritualCircuitMotionHandler = function () {
        if (prefersReducedMotion()) stopAutoplay();
        else startAutoplay();
      };
      motionQuery.addEventListener('change', root._ritualCircuitMotionHandler);
    }

    startAutoplay();
    scheduleSyncActiveMedia(root);
  }

  document.querySelectorAll('[data-ritual-circuit-switch]').forEach(init);

  document.addEventListener('shopify:section:load', function (ev) {
    var root = ev.target && ev.target.querySelector && ev.target.querySelector('[data-ritual-circuit-switch]');
    if (root) init(root);
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    var section = ev.target;
    if (!section || !section.querySelector) return;
    var root = section.querySelector('[data-ritual-circuit-switch]');
    if (root && root._ritualCircuitCleanup) root._ritualCircuitCleanup();
  });
})();
